import type { Transition, Variants } from 'motion/react'

/**
 * Vocabulário de movimento do portal (spec §7.7).
 *
 * Só `transform` e `opacity` são animados: são as duas propriedades que o
 * navegador resolve no compositor, sem recalcular layout. Animar `width`,
 * `height`, `top` ou `left` derruba os 60 fps que a demonstração precisa.
 */
export const spring: Transition = { type: 'spring', stiffness: 380, damping: 32 }

/** Teto de 450 ms para qualquer entrada: acima disso a tela parece lenta. */
const enter: Transition = { duration: 0.35, ease: [0.22, 1, 0.36, 1] }

export const STAGGER_SECONDS = 0.06

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: spring },
}

export const fade: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: enter },
}

export const staggerChildren: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: STAGGER_SECONDS } },
}

/** Shake curto do card de login quando a credencial é recusada (M3). */
export const shake = { x: [0, -8, 8, -4, 4, 0] }

/** Entrada direcional das etapas do wizard (M10). */
export const wizardStep: Variants = {
  hidden: (direction: number) => ({ opacity: 0, x: direction > 0 ? 40 : -40 }),
  visible: { opacity: 1, x: 0, transition: spring },
  exit: (direction: number) => ({ opacity: 0, x: direction > 0 ? -40 : 40, transition: enter }),
}

/** Traço de um SVG sendo desenhado (M12/M13). */
export const drawPath: Variants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: { pathLength: { duration: 0.45, ease: 'easeOut' }, opacity: { duration: 0.1 } },
  },
}
